import axios from "axios";
import BACKEND_URL from "../config";

const transport = axios.create({
    // baseURL: "http://192.168.1.4:8002/api/v1",
    baseURL: BACKEND_URL,
});

transport.interceptors.request.use((config) => {

    const token = localStorage.getItem('accessToken');
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }
    const currentLanguageCode = localStorage.getItem('i18nextLng') || 'default';
    config.headers['local'] = currentLanguageCode;
    config.headers['accept-language'] = currentLanguageCode;
    return config;
}, (error) => {
    return Promise.reject(error);
});
transport.interceptors.response.use(
    (response) => response,
    (error) => {
        // معالجة 401 Unauthorized
        if (error.response && error.response.status === 401) {
            const isLoginRequest = error.config.url.includes('/auth/login');
            const isAlreadyOnLoginPage = window.location.pathname === "/login";

            if (!isLoginRequest && !isAlreadyOnLoginPage) {
                console.error("Unauthorized! Redirecting to login...");
                localStorage.removeItem('accessToken');
                localStorage.removeItem('user');
                localStorage.removeItem('abilities');
                window.location.href = "/login";
            }
        }

        // معالجة 429 Too Many Requests (Rate Limiting)
        if (error.response && error.response.status === 429) {
            const retryAfter = error.response.data?.meta?.retry_after;
            console.warn(`Rate limit exceeded. Retry after ${retryAfter} seconds.`);
        }

        return Promise.reject(error);
    }
);

export default transport;
